// @ts-check
import React from 'react';

import Box from '@liquidweb-dev/undercurrent/Box';
import Stack from '@liquidweb-dev/undercurrent/Stack';
import SignInButton from 'components/SignInButton';
import CartButton from 'components/LeftHandLayout/common/CartButton';
import BrandLogo from 'components/BrandLogo';

const Unauthed = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				gap: 200,
				width: '100%',
			}}
		>
			<BrandLogo />
			<Stack
				direction="row"
				useFlexGap
				sx={{
					alignItems: 'center',
					gap: 150,
				}}
			>
				<CartButton />
				<SignInButton />
			</Stack>
		</Box>
	);
};

export default Unauthed;
